import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";
const InvestContext = React.createContext({
  state: { fundCategory: {} },
  actions: {
    getInvest: () => {},
  },
});

const InvestProvider = ({ children }) => {
  const [fundCategoryList, setFundCategoryList] = useState([]);
  const [domesticList, setDomesticList] = useState([]);
  const [overseasList, setOverseasList] = useState([]);
  const [fundBaseInfo, setFundBaseInfo] = useState([]);
  const [domesticChart, setDomesticChart] = useState([]);
  const [overseasChart, setOverseasChart] = useState([]);
  const [chartType, setChartType] = useState([]);
  const [importance, setImportance] = useState([]);
  const [domesticInfo, setDomesticInfo] = useState({});
  const [overseasInfo, setOverseasInfo] = useState({});

  const getFundCategoryList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/member/invest/fund/category",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setFundCategoryList(res.data);
      } else {
      }
    });
  }, []);

  const getInvestList = useCallback((domesticFlg) => {
    HttpAction({
      url: "api/member/biz/list",
      method: "get",
      params: { domesticFlg: domesticFlg },
    }).then((res) => {
      if (res.code === 200) {
        if (domesticFlg) setDomesticList(res.data);
        else setOverseasList(res.data);
      } else {
      }
    });
  }, []);

  const getFundBaseInfo = useCallback(() => {
    HttpAction({
      url: "api/member/invest/fund/baseinfo",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setFundBaseInfo(res.data);
      } else {
      }
    });
  }, []);

  const getInvestChart = useCallback((domesticFlg) => {
    HttpAction({
      url: "api/member/biz/map/list",
      method: "get",
      params: { domesticFlg: domesticFlg },
    }).then((res) => {
      if (res.code === 200) {
        if (domesticFlg) setDomesticChart(res.data);
        else setOverseasChart(res.data);
      } else {
      }
    });
  }, []);

  const getChartType = useCallback(() => {
    HttpAction({
      url: "api/member/invest/biz/chart/type",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setChartType(res.data);
      } else {
      }
    });
  }, []);

  const getInvestImportance = useCallback(() => {
    HttpAction({
      url: "api/member/invest/biz/chart/operation",
      method: "get",
    }).then((res) => {
      if (res.code === 200) {
        setImportance(res.data);
      } else {
      }
    });
  }, []);

  const getInvestBaseInfo = useCallback((domesticFlg) => {
    HttpAction({
      url: "/api/member/biz/statistic",
      method: "get",
      params: { domesticFlg: domesticFlg },
    }).then((res) => {
      if (res.code === 200) {
        if (domesticFlg) setDomesticInfo(res.data);
        else setOverseasInfo(res.data);
      } else {
      }
    });
  }, []);

  const value = {
    state: {
      fundCategoryList,
      domesticList,
      overseasList,
      fundBaseInfo,
      domesticChart,
      overseasChart,
      chartType,
      importance,
      domesticInfo,
      overseasInfo
    },
    actions: {
      getFundCategoryList,
      getInvestList,
      getFundBaseInfo,
      getInvestChart,
      getChartType,
      getInvestImportance,
      getInvestBaseInfo,
    },
  };

  return (
    <InvestContext.Provider value={value}>{children}</InvestContext.Provider>
  );
};

const { Consumer: InvestConsumer } = InvestContext;

export { InvestProvider, InvestConsumer, InvestContext };

export default InvestContext;
